"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Template_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Template = exports.TemplateStatusEnum = void 0;
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const events_1 = require("../events");
const contact_profile_enum_1 = require("./contact-profile-enum");
const template_lang_1 = require("./template-lang");
var TemplateStatusEnum;
(function (TemplateStatusEnum) {
    TemplateStatusEnum["ACTIVE"] = "active";
    TemplateStatusEnum["INACTIVE"] = "inactive";
})(TemplateStatusEnum = exports.TemplateStatusEnum || (exports.TemplateStatusEnum = {}));
let Template = Template_1 = class Template {
};
Template.EVENTS = (0, events_1.makeEventsForClass)(Template_1);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], Template.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 255,
    }),
    (0, typeorm_1.Index)(),
    __metadata("design:type", String)
], Template.prototype, "path", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: TemplateStatusEnum,
        nullable: false,
        default: TemplateStatusEnum.INACTIVE,
    }),
    __metadata("design:type", String)
], Template.prototype, "status", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'jsonb',
        nullable: true,
    }),
    __metadata("design:type", Object)
], Template.prototype, "context", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
        name: 'created_at',
    }),
    __metadata("design:type", Date)
], Template.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
        name: 'updated_at',
    }),
    __metadata("design:type", Date)
], Template.prototype, "updatedAt", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.OneToMany)(() => template_lang_1.TemplateLang, (templateLang) => templateLang.template, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], Template.prototype, "templateLangs", void 0);
Template = Template_1 = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'Template',
        nameProperties: ['path'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('templates', {
        schema: 'public',
    })
], Template);
exports.Template = Template;
//# sourceMappingURL=template.js.map